import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const USER_GET = 'USER_GET' // 获取用户登录信息
const CLIENT_GET = 'CLIENT_GET' // 获取产品线信息
const UNREACHABLEURL_GET = 'UNREACHABLEURL_GET' // 获取没有权限的url
const CLIENT_USER_GET = 'CLIENT_USER_GET' // 获取产品线用户信息

const defaultState = Immutable.fromJS({
  user: {},
  client: {},
  limitList: []
})

export const userAction = createActions({
  USER_GET: async () => {
    const result = await fetch.get(`/staff/get`)
    return result
  },
  CLIENT_GET: async () => {
    const result = await fetch.get(`/client/get`)
    return result
  },
  CLIENT_USER_GET: async params => {
    const result = await fetch.post(`/user/get`, params)
    return result
  },
  UNREACHABLEURL_GET: async () => {
    const result = await fetch.get(`/staff/getUnreachableUrl`)
    return result
  }
})

const reducer = handleActions(
  {
    [USER_GET]: (state, action) => {
      let curState = state
      const { payload } = action
      curState = curState.set('user', new Map(payload))
      return curState
    },
    [CLIENT_GET]: (state, action) => {
      let curState = state
      const { payload } = action
      curState = curState.set('client', new Map(payload))
      return curState
    },
    [UNREACHABLEURL_GET]: (state, action) => {
      let curState = state
      const { payload } = action
      curState = curState.set('limitList', new List(payload))
      return curState
    }
  },
  defaultState
)

export default reducer
